import { MuiTelInput } from 'mui-tel-input';
import { ChangeEvent, FC, KeyboardEvent } from 'react';
import { FormProps, getMuiSize } from '../helpers';
import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

interface Props extends FormProps {
  value: string;
  onChange?: (value: string, event?: ChangeEvent<HTMLInputElement>) => void;
  onEnter?: (value: string) => void;
  placeholder?: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  phoneInput: {
    '& label.MuiFormLabel-root.Mui-focused': {
      color: theme.palette.common.black,
    },
    '&.Mui-focused': {
      '& fieldset': {
        borderColor: theme.palette.gray,
      },
    },
    '& .MuiInputBase-root': {
      '&.Mui-focused': {
        '& fieldset': {
          borderColor: theme.palette.gray,
        },
      },
      '&.Mui-readOnly fieldset': {
        borderColor: `${theme.palette.divider} !important`,
      },
      '& input.Mui-readOnly, textarea.Mui-readOnly': {
        color: `${theme.palette.darkGray} !important`,
      },
    },
  },
  notchedOutline: {
    borderWidth: '1px !important',
  },
}));

const PhoneInput: FC<Props> = ({
  value,
  onChange,
  onEnter,
  placeholder = '',
  readonly,
  label,
  error,
  name,
  size = 'small',
  required = false,
  disabled = false,
  autoFocus = false,
}) => {
  const styles = useStyles();

  const handleChange = (value: string | undefined) => {
    if (readonly) {
      return;
    }
    onChange && onChange(value || '');
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      onEnter && onEnter(value);
    }
  };

  const isSmall = size === 'small';
  const muiSize = getMuiSize(size);

  return (
    <MuiTelInput
      id={name}
      name={name}
      label={label || undefined}
      variant="outlined"
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      value={value}
      margin={isSmall ? 'none' : 'normal'}
      fullWidth
      autoFocus={autoFocus}
      error={!!error}
      helperText={error}
      disabled={disabled}
      required={required}
      size={muiSize}
      placeholder={placeholder}
      className={styles.phoneInput}
      InputProps={{
        classes: {
          notchedOutline: styles.notchedOutline,
        },
        readOnly: readonly,
      }}
      defaultCountry="US"
      focusOnSelectCountry
    />
  );
};

export default PhoneInput;
